import initLowPowerVideo from 'JsComponents/low-power-video';
import initVideoColumn from 'JsComponents/video-column';
import initProductCards from 'JsComponents/homepage-product-card';
import initHomepageRail from 'JsComponents/homepage-rail';
import initFaqAccordion from 'JsComponents/faq-accordion';
import initPromoBar from 'JsComponents/promo-bar';
import initStackAndSave from 'JsComponents/stack-and-save';
import CarouselSwiper from 'JsComponents/carousel-swiper';

if (!customElements.get('carousel-swiper')) {
  customElements.define('carousel-swiper', CarouselSwiper);
}

document.addEventListener('DOMContentLoaded', () => {
  initLowPowerVideo();
  initVideoColumn();
  initProductCards();
  initHomepageRail();
  initFaqAccordion();
  initPromoBar();
  initStackAndSave();
});
